export enum Tier {
	Free = -1,
	Starter = 0,
	Pro = 1,
	Enterprise = 2,
	ProfessionalPlus = 3
}

export function tierToString(tier:Tier):string{
	if (tier == Tier.Free) {
		return "FREE";
	}
	if (tier == Tier.Starter) {
		return "STARTER";
	}
	if (tier == Tier.Pro){
		return "Professional";
	}
	if (tier == Tier.Enterprise){
		return "Enterprise";
	}
	if (tier == Tier.ProfessionalPlus){
		return "Professional Plus";
	}
	return "ERROR";
}